import React from 'react'
import Card from '@material-ui/core/Card'
import CardMedia from '@material-ui/core/CardMedia'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import { useHistory } from 'react-router-dom'
import withAppconfig from '../../AppContext'
import { Container, Chip, Divider, Grid, Typography, TextField } from '@material-ui/core'
import Button from '@material-ui/core/Button'
// import { useCookies } from 'react-cookie'
import { getPosterUrl } from '../ViewUtils'
import Poster from '../../components/Poster'
import { useTranslation } from 'react-i18next'

const ProShopProductCard = ({ product, personname, appconfig, collection, isAuthRequired, isAuth, selected, onSelected, onCart }) => {
  const history = useHistory()
  const { t } = useTranslation()
  const [selectedVariant, setSelectedVariant] = React.useState(null)
  const [selectedAmount, setSelectedAmount] = React.useState(1)

  // eslint-disable-next-line no-unused-vars
  const { poster, id, variations } = product

  // let _optimizedPoster = ''
  // if (poster && typeof poster === 'object') {
    
  // if (poster && poster.indexOf('.svg') > -1) {
  //   _optimizedPoster = poster
  // } else {
  //   _optimizedPoster = poster
  //     ? poster
  //         .split('/')
  //         .splice(0, poster.split('/').length - 1)
  //         .join('/') +
  //       '/600_' +
  //       poster.split('/').splice(-1)
  //     : ''
  // }

  const handleSelected = () => {
    if (onSelected) {
      onSelected(product)
    }
  }

  let price = ''
  if (variations && variations.length > 0) {
    price = (variations[0].price / 100).toFixed(2).replace('.', ',') + ' €'
  }

  const posterUrl = getPosterUrl(poster, 300)





  if (selected) {

  let variationsSelector = null
  if (product.variations) {
    if (product.variations.length > 1) {
      variationsSelector = product.variations.map((v) => {
        return (
          <Chip
            clickable
            label={v.name + ' ' + (v.price / 100).toFixed(2).replace('.', ',') + ' €'}
            key={'varid-' + v.varid}
            color={selectedVariant?.varid === v.varid ? 'primary' : 'default'}
            variant={selectedVariant?.varid === v.varid ? 'outlined' : 'default'}
            onClick={() => setSelectedVariant(v)}
            style={{ margin: 5 }}
          />
        )
      })
    } else {
      variationsSelector = <Typography variant='h5'>{product.variations[0].name + ' ' + (product.variations[0].price / 100).toFixed(2).replace('.', ',') + ' €'}</Typography>
      if (selectedVariant === null) {
        setSelectedVariant(product.variations[0])
      }
    }
  }


    // full product page with onCart funtionality
    return (
      <Container className='front' style={{ paddingTop: 10 }}>
        <Grid container spacing={3} alignItems='flex-start' >
          <Grid item xs={12} md={6} style={{ textAlign: 'center', paddingTop: 40 }}>
            <Poster data={poster} preferredSize={300} alt={product.displayName} defaultBg={appconfig.logos} />
          </Grid>
          <Grid item xs={12} md={6} style={{ paddingTop: '5em', paddingRight: 20 }}>
            <Typography variant='h4'>{product.displayName.toUpperCase()}</Typography>
            <Divider />
            {variationsSelector}
            <div>
              <Typography variant='h6'>
                {selectedVariant ? selectedVariant.name + ' ' + (selectedVariant.price / 100).toFixed(2).replace('.', ',') + ' €' : null}
              </Typography>
              <Typography variant='caption'>
                {selectedVariant ? t('vat') + ' ' + product.vat + ' %' : null}
              </Typography>
            </div>
            <div>
            <TextField
              label={t('quantity')}
              type='number'
              value={selectedAmount}
              onChange={(e) => setSelectedAmount(Number(e.target.value))}
              inputProps={{ min: 1 }}
              style={{ marginTop: 10, marginBottom: 10 }}
              />
            </div>

            <Button
              variant='contained'
              color='primary'
              disabled={!selectedVariant}
              style={{ marginTop: 10, marginBottom: 10 }}
              onClick={() => onCart({ ...product, selectedVariant } , selectedAmount )}
            >
              {t('add_to_cart')}
            </Button>
            <Divider />
            <Typography variant='body1'>
              <span dangerouslySetInnerHTML={{ __html: product.description }} />
            </Typography>
          </Grid>
        </Grid>
      </Container>
    )
  }

  return (
    <Card style={{ marginTop: 20 }}>
      {posterUrl && <CardMedia image={posterUrl} style={{ paddingTop: '56.25%' }} />}
      <CardContent onClick={handleSelected} style={{ cursor: 'pointer' }}>
        <Grid container direction='row' justifyContent='space-between' alignItems='center'>
          <Grid item xs={12}>
            <Typography variant='h6'>{product.displayName}</Typography>
          </Grid>
          <Grid item xs={6} style={{ textAlign: 'right' }}>
            <Typography variant='subtitle1'>{price}</Typography>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions></CardActions>
    </Card>
  )
}

export default withAppconfig(ProShopProductCard)
